/* eslint-disable */
import { useEffect, useRef } from 'react';
import scrollEventFn from '../scroll_event';
export default function Map() {
  // scroll event
  const scroll01 = useRef(null);
  const scroll02 = useRef(null);
  const scroll03 = useRef(null);
  const scrollArr = [scroll01, scroll02, scroll03];
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // scroll event
    scrollEventFn(scrollArr);
    window.addEventListener('scroll', () => {
      scrollEventFn(scrollArr);
    });
    return () => {
      window.removeEventListener('scroll', () => {
        scrollEventFn(scrollArr);
      });
    };
  }, []);
  // html
  return (
    <div className="contents map">
      <div className="content-title02">찾아오시는 길</div>
      <iframe
        className="scrollBox"
        ref={scroll01}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.1243946686745!2d126.91533387699087!3d37.552132924952154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c98da6cc1da31%3A0x91854d83974dc6ed!2z7ISc7Jq47Yq567OE7IucIOuniO2PrOq1rCDslpHtmZTroZwgOTI!5e0!3m2!1sko!2skr!4v1732000326234!5m2!1sko!2skr"
        width="100%"
        height="450"
        style={{ border: '0' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      <div className="company-con location-con01">
        <div className="location-con">
          <div className="tit" style={{ whiteSpace: 'nowrap' }}>
            오시는 길
          </div>
          <div className="info-box scrollBox" ref={scroll02}>
            <dl>
              <dt>위치</dt>
              <dd>
                (04043) 서울특별시 마포구 양화로 92 유남빌딩 6층
                <br />
                6F, Yanghwa-ro, Mapo-gu, Seoul, Republic of Korea
              </dd>
            </dl>
            <dl>
              <dt>전화번호</dt>
              <dd>02-712-9039</dd>
            </dl>
            <dl>
              <dt>팩스</dt>
              <dd>02-712-9007</dd>
            </dl>
            <dl>
              <dt>E-mail</dt>
              <dd>dxclaim@dxclaim.com</dd>
            </dl>
          </div>
        </div>
      </div>
      <div className="company-con02 location-con02">
        <div className="location-con">
          <div className="tit">대중교통</div>
          <div className="info-box scrollBox" ref={scroll03}>
            <dl>
              <dt>
                버스
                <br />
                <em>(합정역 하차)</em>
              </dt>
              <dd>
                <p className="txt bus01">마포16</p>
                <p className="txt bus02">271, N72</p>
                <p className="txt bus03">7011, 7013A, 7013B</p>
                <p className="txt bus04">200, 2200, 3100, 3100N, 7300, M7731</p>
              </dd>
            </dl>
            <dl>
              <dt>지하철</dt>
              <dd>
                <p className="txt subway2">마포16</p>
                <p className="txt subway6">271, N72</p>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
